import {StyleSheet} from 'react-native';

import {cloud} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    backgroundColor: cloud,
    borderRadius: 3,
  },
});
